export default {
  today: 'Hoje',
  tomorrow: 'Amanhã',
};
